import io from "socket.io-client";
const socket = io.connect(process.env.REACT_APP_SOCKET_URL);
socket.on("connect-success", (clientId) => {
  localStorage.setItem("clientId", clientId);
  navigator.clipboard.writeText(clientId);
});


export default socket;
